const LIVE_PREFIX = 'https://datadesk-prod-origin.californiatimes.com';
const TEST_PREFIX = 'https://elections-2024-backend-dev.s3.amazonaws.com';

// STATE - results, includes president
export const STATE_URL = `${LIVE_PREFIX}/projects/elections-data/2024-03-05/latest-state.json`;

export const DELEGATES_URL = `${LIVE_PREFIX}/projects/elections-data/2024-03-05/latest-delegates.json`;

export const DA_URL = `${LIVE_PREFIX}/projects/elections-data/2024-03-05/latest-DA.json`;

// counties
export const LA_COUNTY_URL = `${LIVE_PREFIX}/projects/elections-data/2024-03-05/la.json`;

export const OC_URL = `${LIVE_PREFIX}/projects/elections-data/2024-03-05/oc.json`;

// embeds
export const EMBED_URL = `${LIVE_PREFIX}/projects/elections-data/2024-03-05/embeds.json`;
export const HLA_URL = `${LIVE_PREFIX}/projects/elections-data/2024-03-05/latest-HLA.json`;

// OTHER
export const GEOGRAPHY_URL =
  'https://datadesk-prod-origin.californiatimes.com/projects/elections-data/2020-11-03/geographies/states/ca.json';

////////

// // STATE - results, includes president
// export const STATE_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2024-03-05/latest-state.json`;

// export const DELEGATES_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2024-03-05/latest-delegates.json`;

// export const DA_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2024-03-05/latest-DA.json`;

// // counties
// export const LA_COUNTY_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2024-03-05/la.json`;

// export const OC_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2024-03-05/oc.json`;

// // embeds
// export const EMBED_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2024-03-05/embeds.json`;
// export const HLA_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2024-03-05/latest-HLA.json`;

// // OTHER
// export const GEOGRAPHY_URL =
//   'https://datadesk-prod-origin.californiatimes.com/projects/elections-data/2020-11-03/geographies/states/ca.json';
